module.exports = {"embedded":"false","defaultView":"Exterior"}